<script>

    
export default{
    props: ['label', 'value']
};

</script>


<style>

.label-field{
    font-weight: bold;
    color: var(--primary-color);
}

.value-field{
    margin-left: 5px;
}

</style>

<template>
    <div>
        <p>
            <span class="label-field">{{label}}:</span>
            <span class="value-field">{{value}}</span>
        </p>
    </div>
</template>